import styled, { css } from "styled-components";

export const Container = styled.div`
  position: relative;
  background: #ffff;
  margin: 20px;
  border-radius: 8px;
`;

export const Complement = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
  font-size: 10px;
  color: rgb(122, 122, 122);
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;

  svg {
    cursor: pointer;
    width: 16px !important;
    height: 16px !important;
    margin: unset !important;
    path {
      color: rgb(0, 0, 255) !important;
      fill: rgb(0, 0, 255) !important;
    }
  }
`;

export const Title = styled.span`
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
  font-family: "Mangueira bold";
  font-size: 12px;
  color: rgb(0, 0, 255);
`;

export const TitleWrapper = styled.div`
  text-transform: uppercase;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 8px;
`;

type UnitListProps = {
  show: boolean;
};

export const UnitsList = styled.div<UnitListProps>`
  display: ${({ show }) => (show ? "block" : "none")};
  padding: 8px;
  padding-top: 0;
`;

export const UnitListTitle = styled.span`
  color: rgb(122, 122, 122);
  font-size: 12px;
  font-family: "Mangueira bold";
`;

export const Divisor = styled.div`
  width: 100%;
  height: 1px;
  background-color: rgb(122, 122, 122);
  margin-bottom: 10px;
`;

export const BottomBar = styled.div`
  text-transform: uppercase;
  background-color: rgb(0, 255, 255);
  color: rgb(0, 0, 255);
  font-family: "Mangueira bold";
  border: none;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  background-color: rgb(0, 255, 255);
  color: rgb(0, 0, 255);
  padding: 10px;
  outline: none !important;
`;

export const UnitsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 232px;
  overflow: overlay;
`;

type UnitItemProps = {
  selected: boolean;
};

export const UnitItem = styled.div<UnitItemProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
  background-color: rgb(239, 239, 239);
  border-radius: 3px;
  padding: 8px;
  cursor: pointer;

  &:hover {
    background-color: rgb(0, 0, 255);
    color: rgb(255, 255, 255);
  }

  ${({ selected }) =>
    selected &&
    css`
      background-color: rgb(0, 0, 255);
      color: rgb(255, 255, 255);
    `}
`;

export const UnitItemComplement = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
  font-size: 10px;
`;

export const UnitItemTitle = styled.span`
  max-width: 140px;
  font-family: "Mangueira bold";
  font-size: 12px;
`;
